import React, { useContext } from 'react';
import { string } from 'prop-types';
import { intlShape } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { path } from 'ramda';
import { isMobile } from 'react-device-detect';

import { propTypes } from '../../../../util/types';
import { createSlug, parse, stringify } from '../../../../util/urlHelpers';
import { NamedLink } from '../../../../components';

import css from './ContactButton.module.css';
import { BookingRequestContext } from '../../hooks/useBookingRequest';
import { openBookModal } from '../../../../components/BookingPanel/BookingPanel.helpers';
import { LISTING_STATE_CLOSED } from '../../../../constants/listing';
import { moment } from '../../../../util/dates';

const ContactButton = (props) => {
  const {
    className,
    intl,
    listing,
    isOwnListing,
    setRouteKey
  } = props;
  const {
    canEstimateBooking,
  } = useContext(BookingRequestContext);
  const location = useLocation();
  const history = useHistory();
  const hasListingState = !!listing.attributes.state;
  const isClosed = hasListingState && listing.attributes.state === LISTING_STATE_CLOSED;
  const listingId = path(['id', 'uuid'], listing);
  const listingTitle = path(['attributes', 'title'], listing);
  const contactText = intl.formatMessage({ id: 'ListingPage.chatbot' });
  const bookText = intl.formatMessage({ id: 'BookingPanel.book' });
  const bookWithoutDataText = intl.formatMessage({ id: 'BookingPanel.bookWithoutData' });
  const classes = classNames(css.root, className);
  // console.log('handleBookingParamsChange formValues', location, formValues);
  const handleBookingParamsChange = (bookingData) => {
    const { pathname, search, state } = location;
    const searchParams = parse(search);
    const dateMaybe = bookingData?.bookingStart ? {
      bookingDate: moment(bookingData.bookingStart).set({ hour: 0 }).toISOString(),
      startTime: moment(bookingData.bookingStart).format('HH:mm'),
      endTime: moment(bookingData.bookingEnd).format('HH:mm'),
    } : {};
    const adultsMaybe = bookingData?.adults ? {
      adults: bookingData?.adults,
    } : {};
    const newSearchParams = {
      ...searchParams,
      ...dateMaybe,
      ...adultsMaybe,
    };
    const searchString = `?${stringify(newSearchParams)}`;
    history.goBack();
    setTimeout(() => {
      history.replace({
        pathname: pathname,
        search: searchString,
      });
      setRouteKey(Date.now());
    }, 100);
  };
  const handleScrollToBookingPanel = (e) => {
    e.preventDefault();
    if (isMobile) {
      openBookModal(isOwnListing, isClosed, history, location);
      return;
    }

    window.scrollTo({
      top: 280,
      behavior: 'smooth',
    });
  };
  if (canEstimateBooking) return (
    <div>
      <NamedLink
        className={css.contact}
        name="ContactPage"
        params={{ id: listingId, slug: createSlug(listingTitle) }}
        to={{ search: location.search, handleBookingParamsChange }}
      >
        {contactText}
      </NamedLink>
      <div className={css.thisPoolIsAvailable}>
        {intl.formatMessage({ id: 'ListingPage.thisPoolIsAvailable' })}
      </div>
      <div
        className={classes}
        onClick={handleScrollToBookingPanel}
      >
        {bookText}
      </div>
    </div>
  );

  return (
    <div
      className={classes}
      onClick={handleScrollToBookingPanel}
    >
      {bookWithoutDataText}
    </div>
  );
};

ContactButton.defaultProps = {
  className: null,
  listing: null,
};

ContactButton.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  listing: propTypes.listing,
};

export default ContactButton;
